module.exports = __webpack_public_path__ + "img/line_B.57c59bd8.png";